module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option-general', {
    attrs: {
      "value": "scroll",
      "label": _vm.$t('edit.sidebar.on_scroll')
    }
  }, [_c('div', [_c('select', {
    staticClass: "klickart-select",
    on: {
      "change": function($event) {
        return _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'exibition_mode_scroll_value',
          value: $event.target.value
        });
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "25"
    },
    domProps: {
      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '25'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_top')) + "\n      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    },
    domProps: {
      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '50'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_middle')) + "\n      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "75"
    },
    domProps: {
      "selected": _vm.boxConfig.advanced.exibition_mode_scroll_value === '75'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.until_page_bottom')) + "\n      ")])])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-d4c0ba5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionmode/options/Scroll.vue
 ** module id = 911
 ** module chunks = 1
 **/